export function escapeReactRoute(path: string): string {
    if (path === "") {
        return path;
    }
    return path.replace(/([:()$*\\])/g, "\\$1");
}
